
// Get all agences
export const getAgencesStart =()=>({
    type: "GET_AGENCE_START",
});
export const getAgencesSuccess =(agences)=>({
    type: "GET_AGENCES_SUCCESS",
    payload: agences,
});
export const getAgencesFailure =(error)=>({
    type: "GET_AGENCES_FAILURE",
    payload: error,
});


// Add one agence
export const addAgenceStart =()=>({
    type: "ADD_AGENCE_START",
});
export const addAgenceSuccess =(agence)=>({
    type: "ADD_AGENCE_SUCCESS",
    payload: agence,
});
export const addAgenceFailure =(error)=>({
    type: "ADD_AGENCE_FAILURE",
    payload: error,
});

// Update one agence
export const updateAgenceStart =()=>({
    type: "UPDATE_AGENCE_START",
});
export const updateAgenceSuccess =(agence)=>({
    type: "UPDATE_AGENCE_SUCCESS",
    payload: agence,
});
export const updateAgenceFailure =(error)=>({
    type: "UPDATE_AGENCE_FAILURE",
    payload: error,
});

export const getAgencesByWilayaSuccess =(agences)=>({
    type: "GET_AGENCES_BY_WILAYA_SUCCESS",
    payload: agences,
});